import React from 'react';
import style from './ExitScreen.css';
import { buildAssetUrl } from '../../helpers';
const ExitScreenComponent = ({ exitScreen, exitClick }) => {
    const htmlOptions = {
        createYourOwn: (React.createElement("div", { className: style.exitHtml },
            React.createElement("div", { className: style.button }, " Create Your Own"),
            React.createElement("div", null, " on "),
            React.createElement("img", { src: buildAssetUrl('assets/images/logos/ayvri-logo-color.svg'), alt: 'ayvri' }))),
    };
    return (React.createElement("div", { className: style.exitScreen }, exitScreen.map(item => (React.createElement("div", { key: item.link, className: style.exitItem, onClick: () => exitClick(item.link) }, item.component ? htmlOptions[item.component] : React.createElement("img", { src: item.image, alt: item.link }))))));
};
export default ExitScreenComponent;
